export const cibRuby = ["32 32","<path d='M26.875 0.109c4.043 0.703 5.193 3.464 5.104 6.36l0.021-0.043-1.817 23.855-23.641 1.62c-1.963-0.084-6.344-0.261-6.541-6.38l2.193-4 3.76 8.781 0.672 1.561 3.739-12.192-0.041 0.011 0.021-0.043 12.339 3.944-1.86-7.245-1.317-5.199 11.755-0.76-0.817-0.677-8.443-6.885 4.88-2.719zM0 25.453v0.031-0.036zM6.839 6.765c4.749-4.713 10.875-7.495 13.229-5.12 2.348 2.371-0.141 8.141-4.896 12.844-4.751 4.713-10.803 7.647-13.151 5.276-2.355-2.364 0.057-8.287 4.817-13z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-ruby.js
// module id = null
// module chunks = 